export const PORTONE_STORE_ID = "store-0464b693-131a-4a2a-83e0-49a3c6454932";

// 실판매는 네이버 스마트스토어에서 처리합니다. /payment 상세 페이지의 구매 버튼이
// 아래 주소로 바로 이동합니다.
const NAVER_STORE = {
  linkedin: "https://smartstore.naver.com/tangible/products/12960331255",
  instagram: "https://smartstore.naver.com/tangible/products/12474459290",
};

export const PG_CHANNELS = {
  kakao: {
    label: "카카오페이",
    channelKey: "channel-key-eb8dd631-a2ba-4c26-80d7-9035b55567aa",
    payMethod: "EASY_PAY",
    easyPay: { easyPayProvider: "KAKAOPAY" },
    color: "yellow",
    buttonClass: "bg-yellow-400 hover:bg-yellow-300 text-black",
    badgeClass: "bg-yellow-400/20 text-yellow-300 border-yellow-400/30",
    tabClass: "border-yellow-400 text-yellow-300",
    infoText: "EASY_PAY / KAKAOPAY",
  },
};

export const PRODUCTS = {
  linkedin: {
    name: { ko: "TMTT 링크드인 태그", en: "TMTT LinkedIn Tag" },
    price: 13900,
    currency: "KRW",
    description: { ko: "NFC 링크드인 TMTT 태그", en: "NFC LinkedIn TMTT Tag" },
    image: "/linkedin_tags.png",
    naverUrl: NAVER_STORE.linkedin,
    detailImages: [
      "/details/details-page1.png",
      "/details/details-page2.png",
      "/details/details-page3.png",
    ],
    headline: {
      ko: "링크드인 프로필을 더 빠르게 연결하세요.",
      en: "Connect your LinkedIn profile faster.",
    },
    detail: {
      ko: "명함이나 네트워킹 자리에서 태그 한 번으로 LinkedIn 프로필을 바로 열 수 있는 TMTT NFC 태그입니다.",
      en: "A TMTT NFC tag that instantly opens your LinkedIn profile with a single tap at networking events or with business cards.",
    },
    features: {
      ko: [
        "스마트폰 태그 한 번으로 LinkedIn 프로필 이동",
        "오프라인 명함 대체 및 네트워킹 전환율 개선",
        "TMTT.Link 환경에서 간단히 연결 주소 관리 가능",
      ],
      en: [
        "Instantly navigate to LinkedIn profile with a single tap",
        "Replace offline business cards and improve networking conversion",
        "Easily manage connection URLs in the TMTT.Link environment",
      ],
    },
  },
  github: {
    name: { ko: "TMTT 깃허브 태그", en: "TMTT GitHub Tag" },
    price: 13900,
    currency: "KRW",
    description: { ko: "NFC 깃허브 TMTT 태그", en: "NFC GitHub TMTT Tag" },
    image: "/details/github_detail.png",
    // 깃허브 태그는 아직 별도 상품 페이지가 없어 링크드인 상품으로 연결합니다.
    naverUrl: NAVER_STORE.linkedin,
    detailImages: [
      "/details/details-page1.png",
      "/details/details-page2.png",
      "/details/details-page3.png",
    ],
    headline: {
      ko: "깃허브 프로필과 포트폴리오를 더 빠르게 공유하세요.",
      en: "Share your GitHub profile and portfolio faster.",
    },
    detail: {
      ko: "채용 행사, 개발 밋업, 포트폴리오 소개 자리에서 태그 한 번으로 GitHub 프로필이나 대표 저장소를 바로 열 수 있는 TMTT NFC 태그입니다.",
      en: "A TMTT NFC tag that instantly opens your GitHub profile or main repository with a single tap at hiring events, developer meetups, or portfolio showcases.",
    },
    features: {
      ko: [
        "스마트폰 태그 한 번으로 GitHub 프로필 또는 대표 저장소 연결",
        "개발자 포트폴리오 공유를 더 빠르고 간편하게 구성",
        "오프라인 네트워킹과 채용 자리에서 즉시 활용 가능",
      ],
      en: [
        "Instantly connect to GitHub profile or main repository with a single tap",
        "Configure developer portfolio sharing faster and easier",
        "Immediately usable at offline networking and hiring events",
      ],
    },
  },
  instagram: {
    name: { ko: "TMTT 인스타그램 태그", en: "TMTT Instagram Tag" },
    price: 13900,
    currency: "KRW",
    description: { ko: "NFC 인스타그램 TMTT 태그", en: "NFC Instagram TMTT Tag" },
    image: "/instagram_tags.jpg",
    naverUrl: NAVER_STORE.instagram,
    detailImages: [
      "/details/details-page1.png",
      "/details/details-page2.png",
      "/details/details-page3.png",
    ],
    headline: {
      ko: "인스타그램 계정 유입을 오프라인에서도 만드세요.",
      en: "Drive Instagram traffic even from offline locations.",
    },
    detail: {
      ko: "매장, 팝업, 행사 현장에서 고객이 스마트폰으로 태그하면 인스타그램 계정으로 자연스럽게 연결되는 TMTT NFC 태그입니다.",
      en: "A TMTT NFC tag that seamlessly connects customers to your Instagram account when they tap with their smartphones at stores, pop-ups, or events.",
    },
    features: {
      ko: [
        "태그 한 번으로 Instagram 프로필 또는 콘텐츠 연결",
        "오프라인 접점에서 팔로우 유도",
        "간단한 설치로 바로 사용할 수 있는 NFC 태그",
      ],
      en: [
        "Connect to Instagram profile or content with a single tap",
        "Drive follows from offline touchpoints",
        "NFC tag ready to use with simple setup",
      ],
    },
  },
};
